import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import fetchData from "verticales/FetchData";
import ViewGraphicCost from "./componentes/viewGraphicCostos";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";

const CostosSiesa = () => {
  const [data, setData] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [periodoOptions, setPeriodoOptions] = useState([]);
  const [consultaTexto, setConsultaTexto] = useState("");

  useEffect(() => {
    fetchAniosMes();
  }, []);

  const fetchAniosMes = async () => {
    const params = { action: "get" };
    try {
      const result = await fetchData(url, "costos", params);
      console.log("result.....", result.rows);
      setData(result);

      const options = Array.isArray(result?.rows)
        ? result.rows.map((r) => String(r?.anio_mes ?? "")).filter(Boolean)
        : [];

      setPeriodoOptions([...new Set(options)]);
    } catch (error) {
      console.log("Error al consultar el Api", error);
    }
  };

  //INICIO CONSULTAR -- parametro utilizado para enviar el texto del prompt (Nuevo)
  const consultar = async () => {
    const params = {
      action: "get-year",
      query: consultaTexto,
    };

    try {
      const result = await fetchData(url, "costos", params);
      console.log("consulta filtrada ->", result);
    } catch (e) {
      console.log("Error al consultar el Api", e);
    }
  };
  //FIN CONSULTAR -- parametro utilizado para enviar el texto del prompt (Nuevo)

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ViewGraphicCost data={data} />

      <Footer />
    </DashboardLayout>
  );
};

export default CostosSiesa;
